import { create } from 'zustand';
import type { AuthMode, AuthStatus, Me } from './types';

/**
 * Session state for React (the access token itself lives in token-store, out of
 * React). `status` starts `unknown` until the initial silent auth resolves, so the
 * app can show a splash instead of flashing the login screen.
 */
interface AuthState {
  status: AuthStatus;
  user: Me | null;
  /** Platform auth mode from GET /auth/mode; null until boot finishes reading it. */
  mode: AuthMode | null;
  set: (next: Partial<{ status: AuthStatus; user: Me | null; mode: AuthMode | null }>) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: 'unknown',
  user: null,
  mode: null,
  set: (next) => set(next),
}));
